"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ng2_dragula_1 = require("ng2-dragula");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var draggable_column_model_1 = require("./draggable-column.model");
var abstract_destruction_subject_1 = require("../abstract-destruction-subject");
var operators_1 = require("rxjs/operators");
require("./sis-table-builder.component.scss");
var SisTableBuilder = /** @class */ (function (_super) {
    __extends(SisTableBuilder, _super);
    function SisTableBuilder(communicationService, kbService) {
        var _this = _super.call(this) || this;
        _this.communicationService = communicationService;
        _this.kbService = kbService;
        _this.fields = {};
        _this.state = {};
        _this.colFields = [];
        _this.scrollModels = [];
        _this.resizing = false;
        return _this;
    }
    SisTableBuilder.prototype.ngOnInit = function () {
        var _this = this;
        this.initDragula();
        this.prepareColumns();
        this.communicationService.peerSubject.pipe(operators_1.filter(function (data) { return data.key === idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED; }), operators_1.takeUntil(this.destroySubject$)).subscribe(function () {
            _this.colFields = [];
        }, console.error);
    };
    SisTableBuilder.prototype.isEmpty = function () {
        return this.colFields.length === 0;
    };
    SisTableBuilder.prototype.deleteColumn = function (id) {
        this.colFields.splice(this.colFields.findIndex(function (col) { return col.id == id; }), 1);
        this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
            state: {
                'colSystemNames': this.colFields.map(function (field) { return field.systemName; }),
            },
        }));
        this.communicationService.peerSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.PREVIEW, this.colFields));
    };
    SisTableBuilder.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this.dragulaService) {
            this.dragulaService.destroy('table-items');
        }
    };
    SisTableBuilder.prototype.ngAfterViewInit = function () {
        this.documentIsRightToLeft = (document.dir === 'rtl');
    };
    SisTableBuilder.prototype.resizeEvent = function (event) {
        if (this.resizing && this.resizedCell) {
            var colSize = this.containerWidth / 12;
            var diff = void 0;
            diff = (event.clientX - this.xBeforeResizing);
            var columns = diff / colSize;
            if (this.documentIsRightToLeft) {
                if (this.resizedCell.cellCount - columns >= 1) {
                    this.resizedCell.cellCount -= columns;
                }
                else {
                    this.resizedCell.cellCount = 1;
                }
            }
            else {
                this.resizedCell.cellCount += columns;
            }
        }
        this.xBeforeResizing = event.clientX;
    };
    SisTableBuilder.prototype.releaseResize = function (event) {
        this.resizing = false;
        if (this.resizedCell) {
            var expectedSize = Math.round(this.resizedCell.cellCount);
            if (expectedSize >= 1) {
                this.resizedCell.cellCount = expectedSize;
            }
            else {
                this.resizedCell.cellCount = 1;
            }
        }
        this.resizedCell = null;
        this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
            state: {
                'cellCounts': this.colFields.map(function (field) { return field.cellCount; }),
            },
        }));
    };
    SisTableBuilder.prototype.getColumnSize = function (cell) {
        if (cell && cell.cellCount) {
            var size = cell.cellCount / 12 * 100;
            if (size <= 0) {
                size = 1;
            }
            else if (size >= 100) {
                size = 100;
            }
            return size;
        }
    };
    SisTableBuilder.prototype.resizeClickEvent = function (event, cell) {
        this.containerWidth = this.tableContainer.nativeElement.clientWidth;
        this.resizing = true;
        this.resizedCell = cell;
        this.xBeforeResizing = event.clientX;
        event.preventDefault();
        event.stopPropagation();
    };
    SisTableBuilder.prototype.scrollRight = function () {
        var _this = this;
        if (!this.scrollIntervalId) {
            this.scrollIntervalId =
                setInterval(function () { return _this.tableContainer.nativeElement.scrollBy(2, -0); }, 1);
        }
    };
    SisTableBuilder.prototype.scrollLeft = function () {
        var _this = this;
        if (!this.scrollIntervalId) {
            this.scrollIntervalId =
                setInterval(function () { return _this.tableContainer.nativeElement.scrollBy(-2, 0); }, 1);
        }
    };
    SisTableBuilder.prototype.stopScrolling = function () {
        if (this.scrollIntervalId) {
            clearInterval(this.scrollIntervalId);
            this.scrollIntervalId = undefined;
        }
    };
    SisTableBuilder.prototype.trackByFunc = function (index, columnField) {
        return columnField.id;
    };
    SisTableBuilder.prototype.prepareColumns = function () {
        var _this = this;
        if (this.fields.field && this.state.colSystemNames) {
            var tableField = this.fields.field;
            var cols_1 = this.state.colSystemNames;
            var cellCounts_1 = this.state.cellCounts;
            this.kbService.getMetaFields(tableField.getCompoundCategorySystemName())
                .pipe(operators_1.takeUntil(this.destroySubject$))
                .subscribe(function (metaFields) {
                cols_1.map(function (col, index) {
                    var draggableColumnModel = new draggable_column_model_1.DraggableColumnModel(metaFields.find(function (meta) { return meta.getSystemName() === col; }));
                    if (cellCounts_1 && cellCounts_1.length > index) {
                        draggableColumnModel.cellCount = cellCounts_1[index];
                    }
                    _this.colFields.push(draggableColumnModel);
                });
            }, console.error);
        }
    };
    SisTableBuilder.prototype.initDragula = function () {
        var _this = this;
        this.dragulaService.dropModel.pipe(operators_1.filter(function (value) {
            return value[0] === 'table-items';
        }), operators_1.takeUntil(this.destroySubject$)).subscribe(function (value) {
            var elem = value[1];
            if (elem.id === 'new_field') {
                var draggedColumn = _this.colFields.find(function (item) { return !item.checkedInLayout; });
                if (draggedColumn) {
                    draggedColumn.checkedInLayout = true;
                }
            }
            _this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
                state: {
                    'colSystemNames': _this.colFields.map(function (field) { return field.systemName; }),
                    'cellCounts': _this.colFields.map(function (field) { return field.cellCount; }),
                },
            }));
            _this.communicationService.peerSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.PREVIEW, _this.colFields));
        }, console.error);
        this.dragulaService.over.pipe(operators_1.filter(function (value) {
            return value[0] === 'table-items';
        }), operators_1.takeUntil(this.destroySubject$)).subscribe(function (value) {
            var container = value[2];
            if (container.id === 'left_scroll') {
                _this.scrollLeft();
            }
            if (container.id === 'right_scroll') {
                _this.scrollRight();
            }
        }, console.error);
        this.dragulaService.drag.pipe(operators_1.filter(function (value) {
            return value[0] === 'table-items';
        }), operators_1.takeUntil(this.destroySubject$)).subscribe(function (value) {
        }, console.error);
        this.dragulaService.out.pipe(operators_1.filter(function (value) {
            return value[0] === 'table-items';
        }), operators_1.takeUntil(this.destroySubject$)).subscribe(function (value) {
            _this.stopScrolling();
        }, console.error);
        this.dragulaService.cloned.pipe(operators_1.filter(function (value) {
            return value[0] === 'table-items';
        }), operators_1.takeUntil(this.destroySubject$)).subscribe(function (value) {
            var elem = value[1];
            if (elem.id === 'dropped_items') {
                var elemId_1 = elem.getAttribute('col_id');
                var colField = _this.colFields.find(function (col) { return col.id === elemId_1; });
                if (colField) {
                    elem.classList.add('sis-form-builder__component--active');
                    elem.classList.add('sis-form-builder__component--col-' + colField.cellCount);
                }
            }
            else {
                elem.classList.add('sis-form-builder__component--new');
                elem.classList.add('sis-form-builder__component--col-3');
            }
        }, console.error);
        var context = this;
        this.tableDragulaOptions = {
            direction: 'horizontal',
            copy: function (el, source) {
                return el.id === 'new_field';
            },
            moves: function (el, source, handle) {
                if (el.id === 'new_field') {
                    var checkedSysName_1 = el.getAttribute('col_systemName');
                    return context.colFields.findIndex(function (col) { return col.systemName === checkedSysName_1; }) === -1;
                }
                return true;
            },
        };
        this.dragulaService.setOptions('table-items', this.tableDragulaOptions);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisTableBuilder.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisTableBuilder.prototype, "fields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", ng2_dragula_1.DragulaService)
    ], SisTableBuilder.prototype, "dragulaService", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisTableBuilder.prototype, "state", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisTableBuilder.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.ViewChild('tableContainer', { read: core_1.ElementRef }),
        __metadata("design:type", core_1.ElementRef)
    ], SisTableBuilder.prototype, "tableContainer", void 0);
    __decorate([
        core_1.HostListener('document:mousemove', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SisTableBuilder.prototype, "resizeEvent", null);
    __decorate([
        core_1.HostListener('document:mouseup', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [MouseEvent]),
        __metadata("design:returntype", void 0)
    ], SisTableBuilder.prototype, "releaseResize", null);
    SisTableBuilder = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-table-builder',
            template: require('./sis-table-builder.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "<sis-table-builder [category]=\"%{category}\" [dragulaService]=\"dragulaService\"\n                                                [currentLanguageId]=\"%{currentLanguageId}\"\n                                                 [fields]=\"%{fields}\" [state]=\"%{state}\">\n                              </sis-table-builder>",
        }),
        __metadata("design:paramtypes", [idm_dynamic_controls_metadata_1.CommunicationService,
            idm_kb_service_client_js_1.KbService])
    ], SisTableBuilder);
    return SisTableBuilder;
}(abstract_destruction_subject_1.AbstractDestructionSubject));
exports.SisTableBuilder = SisTableBuilder;
//# sourceMappingURL=sis-table-builder.component.js.map